import { apiRequest } from '@common/api/utils';

const BASE_URL = '/api/v3/acs/registration';
const ACS_REQUEST_ENDPOINT = `${BASE_URL}/register`;
const ACS_STATUS_ENDPOINT = `${BASE_URL}/check-registration`;

export const requestACS = (queryParams) => {
  const result = apiRequest(
    'POST',
    ACS_REQUEST_ENDPOINT,
    {
      ...queryParams,
    },
  );

  return result;
};

export const getACSStatus = () => {
  const acsResult = apiRequest(
    'GET',
    ACS_STATUS_ENDPOINT,
  );

  return acsResult;
};
